import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { openTSDialog } from 'src/app/helpers/methods';
import { openDefaultLoginDialog, openSignUpDialog, openTermsAndConditionsDialog, signup, socialMediaClicked } from '@app-core/components/home/home.component';
import { SignupService } from '@app-services/signup/signup.service';
import { BoardsService } from '@app-services/boarrds/boards.service';
import { UserService } from '@app-services/user/user.service';
import { TenantConstant } from '@app-constants/tenant.constant';
@Component({
  selector: 'app-jee-liveclass',
  templateUrl: './jee-liveclass.component.html',
  styleUrls: ['./jee-liveclass.component.css']
})
export class JeeLiveclassComponent implements OnInit {
  signup = signup;
  openDefaultLoginDialog = openDefaultLoginDialog;
  openTermsAndConditionsDialog = openTermsAndConditionsDialog;
  socialMediaClicked = socialMediaClicked;
  openTSDialog = openTSDialog;
  tenant:any = TenantConstant.tenant;
    @ViewChild('content') public content: any;
    mobileNumberForm: FormGroup;
    mobileNumberValid = false;
    constructor(
      private dialog: MatDialog,
  public signUpService: SignupService,
  private gaService: GAnalyticsService,
  private fb:FormBuilder,
  private gradesService: BoardsService,
  public userService: UserService,
  ) { }
  
    ngOnInit(): void {
      this.mobileNumberForm = this.fb.group({
        phone: ['',[Validators.required]]
      })
    }
    openSignUpDialog(): void {
      this.openTSDialog({
        message: 'One more step and you are all set',
        source: 'Liveclasses',
        phone: this.mobileNumberForm.value.phone,
        countryCode: '+91',
        isJEE: true,
      })
    }
    onInputChange() {
  
      let Value = this.mobileNumberForm.value.phone;
      let stringLength = String(Value).length;
      if (Value && stringLength > 10) {
        let newValue = parseInt(String(Value).slice(0, 9));
        this.mobileNumberForm.value.phone = newValue;
      }
  
      if (stringLength > 9) {
        this.mobileNumberValid = true;
      } else {
        this.mobileNumberValid = false;
      }
  
  
    }
  
    ngOnDestroy(){
    }
  }
